export const enum ActionPointStatus {
    Open = 0,
    Send = 1,
    Processed = 2,
    Ignore = 3,
    OnHold = 4,
}
